<template>
  <main>
    <NodePage v-if="node" v-bind="node" />
  </main>
</template>

<script lang="ts" setup>
definePageMeta({
  name: 'privacy-policy',
  drupalFrontendRoute: true,
  languageMapping: {
    de: '/datenschutzerklaerung',
    en: '/en/privacy-policy',
    fr: '/fr/declaration-de-protection-des-donnees',
    it: '/it/informativa-sulla-privacy',
  },
})

const { entity: node } = await useDrupalRouteQuery('page')
await renderPageDependencies()

defineOptions({
  name: 'PagePrivacyPolicy',
})
</script>
